<div class="horizontal-select">
	<au-cmms-status-label
		class="cursor-pointer"
		[status]="status"
		[matMenuTriggerFor]="statusList"
		(click)="$event.stopPropagation()"
		#statusMenuTrigger="matMenuTrigger"
	>
	</au-cmms-status-label>
</div>

<mat-menu #statusList="matMenu" class="au-status-select" yPosition="below">
	<div class="statuses-container">
		@for (status of statuses; track status) {
			<div
				class="work-order-status cursor-pointer"
				(click)="$event.stopPropagation(); selectStatus(status)"
			>
				<au-cmms-status-label [status]="status"> </au-cmms-status-label>
			</div>
		}
	</div>
</mat-menu>
